/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let blogApiURL = root.blogApiUrl.link;
let publicBlogApiURL = root.publicBlogApiUrl.link;
let publicSingleBlogDetailsApiURL = root.publicSingleBlogDetailsApiUrl.link;
let suggestionBlogApiURL = root.suggestionBlogApiUrl.link;
let blogListForSuApiURL = root.blogListForSuApiUrl.link;
let voteBlogApiUrl = root.voteBlogApiUrl.link;
let voteBlogInfoApiUrl = root.voteBlogInfoApiUrl.link;
export default {
  state: {
    blogListState:{},
    blogDetailsByIdState:{},
    publicBlogListState:{},
    publicSingleBlogDetailsByIdState:{},
    suggestionBlogListState:{},
    getBlogVoteInfoState:{}
  },
  mutations: {
    suggestionBlogListMutation(state, value) {
      Vue.set(state, 'suggestionBlogListState', value);
    },
    publicBlogListMutation(state, value) {
      Vue.set(state, 'publicBlogListState', value);
    },
    blogListMutation(state, value) {
      Vue.set(state, 'blogListState', value);
    },
    blogDetailsByIdMutation(state, value) {
        Vue.set(state, 'blogDetailsByIdState', value);
    },
    publicSingleBlogDetailsByIdMutation(state, value) {
      Vue.set(state, 'publicSingleBlogDetailsByIdState', value);
    },
    getBlogVoteInfoMutation(state, value) {
      Vue.set(state, 'getBlogVoteInfoState', value);
    }
  },
  actions: {
    getBlogVoteInfoAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(voteBlogInfoApiUrl + payload.id + '/').then(
            (response) => {
              context.commit('getBlogVoteInfoMutation', response.data);
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    getSuggestionBlogListAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(suggestionBlogApiURL).then(
            (response) => {
              context.commit('suggestionBlogListMutation', response.data);
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    getPublicBlogDetailsByIdAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(publicSingleBlogDetailsApiURL + payload.id + '/').then(
            (response) => {
              context.commit('publicSingleBlogDetailsByIdMutation', response.data.data);
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    getPublicBlogListAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(publicBlogApiURL).then(
            (response) => {
              context.commit('publicBlogListMutation', response.data);
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    getBlogListAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(blogApiURL).then(
            (response) => {
              context.commit('blogListMutation', response.data);
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    getBlogListForSuperUserAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(blogListForSuApiURL + payload.id + '/').then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    getBlogDetailsByIdAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(blogApiURL + payload.id + '/').then(
            (response) => {
              context.commit('blogDetailsByIdMutation', response.data.data);
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    createBlogDetailsAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(blogApiURL, payload).then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    updateBlogDetailsAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.patch(blogApiURL + payload.data.id + '/', payload.data.data).then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    removeBlogDetailsAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete(blogApiURL + payload.id + '/').then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    },
    blogVoteAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post(voteBlogApiUrl, payload).then(
            (response) => {
              resolve(response);
            }
          )
          .catch((error) => {
            reject(error);
          })
      })
    }
  },
  getters: {
    blogListGetters: state => state.blogListState,
    blogDetailsByIdGetters: state => state.blogDetailsByIdState,
    publicBlogListGetters: state => state.publicBlogListState,
    publicSingleBlogDetailsByIdGetters: state => state.publicSingleBlogDetailsByIdState,
    suggestionBlogListGetters: state => state.suggestionBlogListState,
    getBlogVoteInfoGetters: state => state.getBlogVoteInfoState
  }
}